export const theme = {
    name: 'congreet',
    customRoutes: [{
        path: 'login',
        loadChildren: () => import('../app/pages/login/login.module').then(m => m.LoginPageModule),
    },
    {
        path: 'login/event-key/:event-key',
        loadChildren: () => import('../app/pages/login/login.module').then(m => m.LoginPageModule),
    },
    {
        path: 'login/access-key/:event-key',
        loadChildren: () => import('../app/pages/login/login.module').then(m => m.LoginPageModule),
    },
    {
        path: 'register',
        loadChildren: () => import('../app/pages/registration/registration.module').then(m => m.RegistrationPageModule),
    },
    {
        path: 'register/event-key/:event-key',
        loadChildren: () => import('../app/pages/registration/registration.module').then(m => m.RegistrationPageModule),
    },
    {
        path: 'register/access-key/:event-key',
        loadChildren: () => import('../app/pages/registration/registration.module').then(m => m.RegistrationPageModule),
    },
    {
        path: 'lost-password',
        loadChildren: () => import('../app/pages/lost-password/lost-password.module').then(m => m.LostPasswordPageModule)
    },
    {
        path: 'set-password',
        loadChildren: () => import('../app/pages/set-password/set-password.module').then(m => m.SetPasswordPageModule)
    },
    {
        path: 'toc',
        loadChildren: () => import('../app/pages/toc/toc.module').then(m => m.TocPageModule)
    }]
}
